/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UnsubscribeFromIncidentRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {UnsubscribeFromIncidentResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const unsubscribeFromIncident = (request:UnsubscribeFromIncidentRequest, options?: CashRequestOptions) => post<UnsubscribeFromIncidentRequest, UnsubscribeFromIncidentResponse>("/2.0/cash/unsubscribe-from-incident", request, {...options, rejectOnError: true })